import {
  deleteSubcategoryItemApi,
  editSubcategoryItemApi,
  createSubcategoryItemApi,
  sortSubcategoryItemApi,
  endpoints,
} from '../api';
import {buildRoute} from '../../../http';

export type CreateSubCategoryItemRequest = {
  subCategoryId: string,
  name: string,
};

export type SortSubCategoryItemRequest = {
  originId: string,
  targetId: string,
  subCategoryId: string,
};

export type EditSubCategoryRequest = {
  name: string,
  subcategoryItemId: string,
};

export function createSubcategoryItemService(
  payload: CreateSubCategoryItemRequest
) {
  return createSubcategoryItemApi(payload).toPromise();
}

export function editSubcategoryItemService(
  subCategoryItemId: string,
  name: string
) {
  const route = buildRoute(endpoints.EDIT_SUB_CATEGORY_ITEM, [
    subCategoryItemId,
  ]);

  return editSubcategoryItemApi(
    {
      name,
    },
    {
      route,
    }
  ).toPromise();
}

export function deleteSubcategoryItemService(subCategoryItemId: string) {
  const route = buildRoute(endpoints.DELETE_SUB_CATEGORY_ITEM, [
    subCategoryItemId,
  ]);

  return deleteSubcategoryItemApi({
    route,
  }).toPromise();
}

export function sortSubcategoryItemService(
  payload: SortSubCategoryItemRequest
) {
  return sortSubcategoryItemApi(payload).toPromise();
}
